import React from "react";
import Head from "../../components/Head";
import { Large } from "../../components/Type";
import W from "../../docs/changelog.mdx";
import { SingleFormAppShell } from "../../components/SingleFormAppShell";
import { MDXWrapper } from "../../mdx/settings";
import { Trans, t, msg } from "@lingui/macro";

export default () => {
  return (
    <>
    <SingleFormAppShell title={t`Changelog`} description={t`Sobat Sawer! Berikan dukungan langsung kepada kreator dan komunitas favorit kamu dan bantu mereka terus berkarya melalui Saweria.`}>
      <Large mt="1em" mb="1em">
        Changelog Saweria:
      </Large>

      <MDXWrapper>
        <W />
      </MDXWrapper>
    </SingleFormAppShell>
    </>
  );
};
